import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchAllUserTransactions, fetchCurrentUserGroups } from '../../ducks/user.duck';
import { fetchSpaceListV2 } from '../CircleCommunityPage/CircleCommunityPage.duck';
import { searchGroups } from '../GroupSearchPage/GroupSearchPage.duck';
import { queryUserListings } from '../ProfilePage/ProfilePage.duck';
export const ASSET_NAME = 'landing-page';


export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  const userId = getState().user?.currentUser?.id?.uuid || '';

  return Promise.all([dispatch(fetchPageAssets(pageAsset, true)),
  dispatch(fetchSpaceListV2()),
  dispatch(searchGroups({ page: 1 })),
  dispatch(queryUserListings(userId, config)),
  dispatch(fetchAllUserTransactions()),
  dispatch(fetchCurrentUserGroups())])
    .then(() => {
      return {};
    })
    .catch(e => {
      throw e;
    });
};
